import axios from '../../http_v2'
export default {
    getChannel: (data) => {
        return axios.post('activityservice/channelsetup/list', data)
    },
    addChannel: (data) => {
        return axios.post('activityservice/channelsetup/insert', data)
    },
    updateChannel: (data) => {
        return axios.post('activityservice/channelsetup/update', data)
    },
    add: (data) => {
        return axios.post('activityservice/ticketmanage/save', data)
    },
    update: (data) => {
        return axios.post('activityservice/ticketmanage/update', data)
    },
    del: (data) => {
        return axios.post('activityservice/ticketmanage/remove', data)
    },
    list: (params) => {
        return axios.get('activityservice/ticketmanage/list', params)
    },
    get: (params) => {
        return axios.get('activityservice/ticketmanage/get', params)
    }
}
